import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { getListMember } from 'api/Project/role'
import { getCookie } from 'helper/cookie'

const MemberLayout = styled.div``
const initalState = {
  data: [],
}
const Projectmember = (props) => {
  const { project_id } = props
  const [memberList, setMemberList] = useState(initalState.data)

  const token = getCookie('access_token_admin')
  const getDatListMember = async () => {
    await getListMember({
      project_id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setMemberList([])

          return true
        }
        if (status === 200) {
          await setMemberList(data)
        } else {
          setMemberList([])
          return true
        }
      })
      .catch((error) => {
        setMemberList([])

        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getDatListMember()
    }
  }, [token])
  return (
    <MemberLayout className="projectmember-container">
      <h3>Project Member</h3>
      <div className="box-member">
        {memberList.map((item) => {
          return (
            <div className="sub-layout">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <img className="imageStyle" src={item.pic_display}></img>
                <div>
                  <p>
                    {item.firstname} {item.lastname}
                  </p>
                  <span className="role-name clutter">{item.role_name}</span>
                </div>
              </div>
              <div>
                <span className="small">{item.skill}</span>
              </div>
            </div>
          )
        })}
      </div>
    </MemberLayout>
  )
}

export default Projectmember
